var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "payment-section" } },
    [
      _vm.notification
        ? _c("base-notificator", {
            staticClass: "_my-2",
            attrs: {
              "can-close": false,
              message: _vm.notification.message,
              type: _vm.notification.type,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOrderPayable || _vm.isInBackupPaymentMode
        ? _c(
            "form",
            {
              staticClass: "payment-form _mt-2",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                ref: "paymentElementRef",
                attrs: { "data-qa": "stripe-payment-frame" },
              }),
              _vm._v(" "),
              _vm._t(
                "content",
                function () {
                  return [
                    _vm.isProjectBenefitsAndRisksVisible
                      ? _c("project-benefits-and-risks", {
                          staticClass: "_my-6",
                          attrs: { "is-stretch-pay-visible": false },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("terms-of-service-checkbox-field", {
                      attrs: { name: "model.termsAccepted" },
                      model: {
                        value: _vm.model.termsAccepted,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "termsAccepted", $$v)
                        },
                        expression: "model.termsAccepted",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "gfu-box-actions" }, [
                      _c("div", { staticClass: "gfu-box-actions__item" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "_gfu-link _gfu-link--accent _tc--accent _flex _ai-c",
                            attrs: { href: _vm.projectUrl },
                            on: { click: _vm.onGoBack },
                          },
                          [
                            _c("base-icon", {
                              attrs: {
                                name: "chevron-left _mr-1",
                                "data-qa": "create-order-btn:Back",
                              },
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.Resources.Common.GoBackButton) +
                                "\n                    "
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "gfu-box-actions__item" },
                        [
                          _c(
                            "base-button",
                            {
                              attrs: {
                                type: "submit",
                                theme: "accent",
                                shape: "soft",
                                display: "block",
                                enabled: !_vm.isProcessing,
                                "data-qa": "create-order-btn:Submit",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.submitButtonLabel) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-qa": "create-order-btn:Price",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.amount))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.installmentsSelectedAndPhaseValid
                            ? _c("installments-info-box", {
                                attrs: { amount: _vm.orderAmountWithSymbol },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                null,
                {
                  handleSubmitAction: _vm.handleSubmitAction,
                  isProcessing: _vm.isProcessing,
                  onGoBack: _vm.onGoBack,
                }
              ),
            ],
            2
          )
        : _vm.isAmendOrCreateOrderInSpecificPhase
        ? _c(
            "div",
            [
              _c("terms-of-service-checkbox-field", {
                attrs: { name: "model.termsAccepted" },
                model: {
                  value: _vm.model.termsAccepted,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "termsAccepted", $$v)
                  },
                  expression: "model.termsAccepted",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "gfu-box-actions" },
                [
                  _c(
                    "div",
                    { staticClass: "gfu-box-actions__item _ml-a _pt-0" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "gfu-btn--block",
                          attrs: {
                            theme: "accent",
                            "data-qa": "create-order-btn:Submit",
                          },
                          on: { click: _vm.onSubmit },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.nonPayableButtonLabel) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("progress-overlay", {
                    attrs: { visible: _vm.isProcessing },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "create-order-without-payment",
            _vm._b({}, "create-order-without-payment", { ..._vm.$props }, false)
          ),
      _vm._v(" "),
      _c("progress-overlay", { attrs: { visible: _vm.isProcessing } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }